<!-- <p-listbox class="w-12" [options]="SPRAY_DRIFT_OPTIONS" optionLabel="name" [(ngModel)]="selectedOption"
    [checkbox]="checkbox" [multiple]="multiple" (onChange)="onChange($event)">
</p-listbox> -->

<p-listbox [options]="SPRAY_DRIFT_OPTIONS" [(ngModel)]="selectedOption" optionLabel="name"
    (onChange)="onChange($event)" [disabled]="disabled"/>